import styled from '@emotion/styled'
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { ToggleButton } from '../ToggleButton/ToggleButton.styles'
import RawFormControl from '../FormControl'

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)`
  margin-bottom: 4px;
  ${ToggleButton}:not(:first-of-type) {
    margin-left: 0;
    border-left: 1px;
  }
`

export const FormControl = styled(RawFormControl)`
  > label {
    transform: translate(0, -1.5px) scale(0.75);
    + .MuiToggleButtonGroup-root {
      margin-top: 16px;
    }
  }
`
